"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWizardType = void 0;
var isTypeLinearS_1 = require("../../types/typeGuards/isTypeLinearS");
var isTypeNested_1 = require("../../types/typeGuards/isTypeNested");
var getWizardType = function (args) {
    if (!args.options)
        return 'linearN';
    if (isTypeLinearS_1.isTypeLinearS(args.options))
        return 'linearS';
    if (isTypeNested_1.isTypeNested(args.options))
        return 'nested';
    throw new Error("Wizard error: wrong wizard type, open an issue");
};
exports.getWizardType = getWizardType;
//# sourceMappingURL=getWizardType.js.map